import { render, staticRenderFns } from "./KRUGList.vue?vue&type=template&id=763860af&scoped=true&"
import script from "./KRUGList.vue?vue&type=script&lang=js&"
export * from "./KRUGList.vue?vue&type=script&lang=js&"
import style0 from "./KRUGList.vue?vue&type=style&index=0&id=763860af&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763860af",
  null
  
)

export default component.exports